<template>
  <div id="app" class="app">
    <transition name="fade">
      <StartPanel
        v-show="start_panel_show"
        :rooms="rooms"
        @join_room="JoinAndStart"
        @create_room="CreateAndStart"
        @check_name_room="CheckNameRoom"
        @refresh-rooms="RefreshRooms"
      />
    </transition>
    <b-navbar variant="faded" type="dark" class="bg-secondary p-0 mb-2">
      <b-navbar-brand class="mx-auto select-none">
        СrocLS
        <img
          width="37"
          height="37"
          src="@/assets/image/LogoCanvasLS.png"
          alt="logo"
          class="m-2 rounded select-none"
        />
      </b-navbar-brand>
    </b-navbar>
    <b-container class="col-12 col-sm-11 col-md-10 col-lg-9">
      <b-row class>
        <b-col class="col-12 col-sm-12 col-md-7 col-lg-8 px-0 d-flex">
          <CanvasLS
            class="col-sm-12 mx-0 px-0 border rounded"
            :color="current_color"
            :tool="tool"
            :radius="current_size"
            :artist="artist"
            :actions="actions"
            @new_draw="NewDrawHub"
            @old_draw="OldDrawHub"
            @resize_canvas="canvas_h = $event"
          />
          <div class="col-12 px-lg-0 d-flex mb-1 panel justify-content-between align-items-end">
            <b-col class="ml-2">
              <ToolsPanel class="p-0 mb-1" @change_tool="tool = $event" />
              <ColorPanel @change_color="current_color = $event" />
            </b-col>
            <SizePanel class="col-1 mb-1" @change_size="current_size = $event" />
          </div>
        </b-col>
        <Chat
          :canvas_h="canvas_h"
          :messages="messages"
          @new_msg="NewMsgHub"
          :users="users"
          class="col-12 col-sm-12 col-md-4 col-lg-4 rounded"
        />
      </b-row>
      <b-row class="justify-content-between mt-1 key-tooltip">
        <b-col class="col-2 pl-0 mt-1">
          <kbd>CTRL + Z</kbd> отмена действий.
        </b-col>
        <b-col class="col-2 pl-0 mt-1">
          <kbd>R</kbd> или
          <kbd>Del</kbd> очистка холста.
        </b-col>
        <b-col class="col-2 pl-0 mt-1">
          <kbd>E</kbd> или
          <kbd>Num1</kbd> стерка.
        </b-col>
        <b-col class="col-2 pl-0 mt-1">
          <kbd>F</kbd> или
          <kbd>Num2</kbd> заливка.
        </b-col>
        <b-col class="col-3 pl-0 mt-1">
          <kbd>A</kbd>
          <kbd>D</kbd> или
          <kbd>⬅</kbd>
          <kbd>➡</kbd> выбор цвета.
        </b-col>
        <b-col class="col-3 pl-0 mt-1">
          <kbd>W</kbd>
          <kbd>S</kbd> или
          <kbd>↑</kbd>
          <kbd>↓</kbd> выбор размера.
        </b-col>
        <b-col class="col-3 pl-0 mt-1">
          <kbd>Q</kbd> или
          <kbd>Num0</kbd> предыдущий выбранный цвет.
        </b-col>
      </b-row>
    </b-container>
    <footer class="bg-info text-white mt-3">
      <div class="container p-3">
        <div class="text-center col-sm">
          СrocLS - game «Crocodile» by LeonSadeness © 2020
          <img
            width="30"
            height="30"
            src="@/assets/image/LSG_Rect_512.jpg"
            alt="logo"
            class="rounded"
          />
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import StartPanel from "@/components/StartPanel";
import CanvasLS from "@/components/CanvasLS";
import ColorPanel from "@/components/ColorPanel";
import SizePanel from "@/components/SizePanel";
import ToolsPanel from "@/components/ToolsPanel";
import Chat from "@/components/Chat";
const axios = require("axios").default;
const signalR = require("@aspnet/signalr");
export default {
  components: {
    StartPanel,
    CanvasLS,
    ColorPanel,
    SizePanel,
    ToolsPanel,
    Chat
  },
  data() {
    return {
      url: "http://127.0.0.1:5000",
      current_color: "black",
      current_size: 4,
      canvas_h: 0,
      tool: "brash",
      start_panel_show: false,
      artist: true,
      actions: [],
      // messages = { id: "user_id", msg: "message_text" }
      messages: [],
      // userd = { id: "user_id", name: "name_text", avatar: 0, scores: 500 }
      users: [],
      // rooms = { name: "name_room_text", pass: true, creator: "ID_user" count: 2 }
      rooms: [
        // { name: "name_room_text", pass: true, count: 2 },
        // { name: "name_room_text", pass: false, count: 3 },
        // { name: "namerrrt", pass: true, count: 7 },
        // { name: "name_roryy", pass: false, count: 8 },
        // { name: "name_rllllllltext", pass: true, count: 14 }
      ],
      connect: null
    };
  },
  beforeMount() {
    window.addEventListener("keydown", this.KeyHandler);
    // инициализация переменных окружения
    if (process.env.NODE_ENV === "production") {
      this.url = process.env.VUE_APP_URI_REMOTE_ORIGIN;
      console.log(this.url);
    }

    // axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
    axios.defaults.baseURL = this.url;

    // Получение списка комнат
    this.RefreshRooms();
    // попытка установки соединения с сохраненной сессией
    this.Start();
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.KeyHandler);
  },
  methods: {
    GetToken() {
      return localStorage.token ? localStorage.token : "";
    },
    GetUserId() {
      return localStorage.userId ? localStorage.userId : "";
    },
    // принимает функцию обратного вызова вызываемую при завершении подключения
    async Start(complete) {
      let connection = new signalR.HubConnectionBuilder()
        .withUrl(this.url + "/game", { accessTokenFactory: this.GetToken })
        // .withAutomaticReconnect([0, 0, 10000])
        // .configureLogging(signalR.LogLevel.Error)
        .build();
      this.connect = connection;

      connection.on("NewMsg", this.NewMsg);
      connection.on("NewDraw", this.NewDraw);
      connection.on("OldDraw", this.OldDraw);
      connection.on("UsersList", this.UsersList);
      connection.on("SignOut", this.SignOut);
      connection.onclose(error => {
        console.log("Close, msg - " + error);
        this.start_panel_show = true;
      });

      await connection
        .start()
        .catch(error => {
          this.start_panel_show = true;
        })
        .then(() => {
          if (this.connect.state === signalR.HubConnectionState.Connected) {
            this.start_panel_show = false;
            if (complete) setTimeout(complete, 1000);
          }
        });
      // try {
      //   await connection.start();
      //   console.assert(
      //     connection.state === signalR.HubConnectionState.Connected
      //   );
      //   console.log("connected");
      // } catch (err) {
      //   console.assert(
      //     connection.state === signalR.HubConnectionState.Disconnected
      //   );
      //   console.log(err);
      //   setTimeout(() => this.Start(), 5000);
      // }
    },
    JoinAndStart(e) {
      const url = "/room/join";
      const data = {
        Name: e.name,
        Avatar: e.avatar,
        NameRoom: e.nameRoom,
        PassRoom: e.password
      };
      this.CheckPass(data.NameRoom, data.PassRoom).then(valid => {
        if (valid) {
          e.valid();
          axios
            .post(url, data)
            .then(response => {
              localStorage.token = response.data.access_token;
              localStorage.userId = response.data.username;
            })
            .catch(function(error) {
              console.log(error);
            })
            .then(() => {
              this.Start();
            });
        } else {
          e.invalid();
        }
      });
    },
    async CreateAndStart(e) {
      const url = "/room/create";
      const data = {
        Name: e.name,
        Avatar: e.avatar,
        NameRoom: e.nameRoom,
        PassRoom: e.password
      };

      axios
        .post(url, data)
        .then(response => {
          localStorage.token = response.data.access_token;
          localStorage.userId = response.data.username;
        })
        .catch(error => {
          e.invalid();
          console.log("CreateAndStart - " + error);
        })
        .then(() => {
          this.Start(e.valid);
        });
    },
    // Запрашивает проверку имени комнаты
    // e = { nameRoom: "name_text", valid(), invalid() }
    async CheckNameRoom(e) {
      const url = "/room/check/name";
      const data = {
        Name: "null",
        Avatar: 0,
        NameRoom: e.nameRoom,
        PassRoom: "null"
      };

      let result = await axios.post(url, data).catch(error => {
        if (error.status == 200) e.valid();
        else if (error.status == 400)
          e.invalid("Такое имя комнаты уже занято :c");
        else e.invalid("Сервер недоступен :'c");
      }).then(response =>{ if(response.status == 200) e.valid();});
    },
    // Запрашивает проверку пароля комнаты
    async CheckPass(nameRoom, passRoom) {
      const url = "/room/check/pass";
      const data = {
        Name: "null",
        Avatar: 0,
        NameRoom: nameRoom,
        PassRoom: passRoom
      };

      let result = await axios.post(url, data).catch(function(error) {
        if (error.status == 200) return true;
        else return false;
      });

      return await result;
    },
    
    /**
     * Обновляет список комнат
     * @param {Function} done метод для обратного вызова при завершении обновления
     */
    RefreshRooms(done) {
      const url = "/room/list";
      axios
        .get(url)
        .then(response => {
          this.rooms = response.data;
          done();
        })
        .catch(function(error) {
          console.log(error);
          done();
        });
    },

    // ----- Взаимодействие с Hub -----
    NewMsgHub(e) {
      this.NewMsg({ id: this.GetUserId(), msg: e });
      if (this.connect != null)
        this.connect.invoke("NewMsg", { id: this.GetUserId(), msg: e });
    },
    NewDrawHub(e) {
      this.NewDraw(e);
      if (this.connect != null) this.connect.invoke("NewDraw", e);
    },
    OldDrawHub(e) {
      this.OldDraw(e);
      if (this.connect != null) this.connect.invoke("OldDraw", e);
    },
    // ----- Реализации -----
    SignOut() {
      localStorage.removeItem("token");
      localStorage.removeItem("userId");
    },
    UsersList(e) {
      let obj = JSON.parse(e);
      this.users = obj;
    },
    NewMsg(e) {
      this.messages.push(e);
    },
    NewDraw(e) {
      this.actions.push(e);
    },
    OldDraw(e) {
      let i = this.actions.pop() + e;
      this.actions.push(i);
    }
  }
};
</script>

<style>
.select-none {
  -khtml-user-select: none;
  -o-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
}
.pointer-true {
  pointer-events: all;
}
.app {
  /* font-family: 'Pacifico', cursive; */
  /* font-family: 'Neucha', cursive; */
  font-family: "Underdog", cursive;
  height: 100%;
}
.panel {
  pointer-events: none;
  position: absolute !important;
  bottom: 0;
}
.key-tooltip {
  font-size: 0.7rem;
}
/* Анимация стартовой панели */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>